import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  bankStatementUnableToProvideReasonClosed: {
    id: "funding-application: air bank statement unable to provide reason closed",
    defaultMessage: "Account is closed",
  },
  bankStatementUnableToProvideReasonClosedMultipleMasks: {
    id: "funding-application: air bank statement unable to provide reason closed (multiple masks)",
    defaultMessage: "At least one account is closed",
  },
  bankStatementUnableToProvideReasonOpenedTooRecently: {
    id: "funding-application: air bank statement unable to provide reason opened too recently",
    defaultMessage: "Account was opened too recently",
  },
  bankStatementUnableToProvideReasonOpenedTooRecentlyMultipleMasks: {
    id: "funding-application: air bank statement unable to provide reason opened too recently (multiple masks)",
    defaultMessage: "At least one account was opened too recently",
  },
  bankStatementUnableToProvideReasonOpenedTooRecentlyLabel: {
    id: "funding-application: reconnect air bank statement unable to provide reason opened too recently label",
    defaultMessage:
      "Roughly, when {bankAccountMasks, plural, =1 {was} other {were}} the {bankAccountMasks, plural, =1 {account} other {accounts}} opened?",
  },
  bankStatementUnableToProvideReasonClosedLabel: {
    id: "funding-application: reconnect air bank statement unable to provide reason closed label",
    defaultMessage:
      "Roughly, when {bankAccountMasks, plural, =1 {was} other {were}} the {bankAccountMasks, plural, =1 {account} other {accounts}} closed?",
  },
  bankStatementUnableToProvideReasonOther: {
    id: "funding-application: air bank statement unable to provide reason other",
    defaultMessage: "Other reason",
  },
  bankStatementConfirmProvidedText: {
    id: "funding-application: air bank statement confirm provided heading",
    defaultMessage: "Please confirm you have provided bank statements for the entire time period.",
  },
  bankStatementConfirmProvidedTextHint: {
    id: "funding-application: air bank statement confirm provided hint",
    defaultMessage: "Missing time periods will need to be provided at a later date and will delay your application.",
  },
  bankStatementConfirmProvidedYesText: {
    id: "funding-application: air bank statement confirm provided yes text",
    defaultMessage: "I confirm I have uploaded statements for the period requested",
  },
  bankStatementConfirmProvidedNoText: {
    id: "funding-application: air bank statement confirm provided no text",
    defaultMessage: "No, I am unable to provide some or all statements",
  },
  bankStatementWhyUnableToProvideCheckboxLabel: {
    id: "funding-application: air bank statement why unable to provide checkbox label",
    defaultMessage: "Why are you unable to provide statements?",
  },
});
